import React, { useEffect, useState, useRef } from 'react';
import { AppBar, Checkbox, Drawer, FormControlLabel, Toolbar, Typography, IconButton, Button, Paper } from '@material-ui/core';
import BackIcon from '@material-ui/icons/ChevronLeft';
import { GetData } from '../../controls/helpers/requests';
import { getEnvVariable } from '../../../modules/environmentalList';
import { createRequest, requestApi as requestApiNew } from '../../controls/helpers/rest';

export default function TermsAndCond({ handleAgreement, handleClose, agreement, url, SITE_PERMIT_TYPE_ID, openTerms }) {
    const [tAndC, settAndC] = useState();
    const [showAgreement, setShowAgreement] = useState(false);
    const pdfContainerRef = useRef(null);

    useEffect(() => {
        let arrayUrl = [
            { url: url.get.url + '/' + SITE_PERMIT_TYPE_ID, type: 'get' },
        ];
        Promise.all(arrayUrl.map(each => requestApiNew(createRequest(each)))).then(res => {
            const [tAndC] = res;
            if (tAndC && tAndC.Id && tAndC.TermsAndConditionsStr) {
                let url = getEnvVariable('TemplateAPI') + `/api/Template/Default/${parseInt(atob(tAndC.TermsAndConditionsStr))}`;
                GetData(url).then(template => {
                    settAndC(template.fileContentPDF);
                });
            }
        }).catch(ex => {
            console.error(ex);
        });
    }, [SITE_PERMIT_TYPE_ID, url]);

    const handleScroll = () => {
        const container = pdfContainerRef.current;
        const bufferHeight = 30;
        const compareHeight = container.scrollHeight - container.scrollTop;
        if (compareHeight - bufferHeight <= container.clientHeight || compareHeight === container.clientHeight
            || compareHeight + bufferHeight >= container.clientHeight) {
            setShowAgreement(true);
        }
    };
    
    return (
        <Drawer anchor="right" PaperProps={{ style: { width: window.innerWidth - 520 } }} open={openTerms}>
            <AppBar position="static" color='primary' elevation={0}>
                <Toolbar variant="dense">
                    <Typography variant="h6" color="inherit">
                        Terms and Conditions
                    </Typography>
                    <div className='flex-grow-1'></div>
                    <IconButton color="inherit" onClick={handleClose} title="Back">
                        <BackIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Paper ref={pdfContainerRef} onScroll={handleScroll} style={{ height: '80vh', overflowY: 'auto', padding: '16px' }}>
                {tAndC && (
                    <iframe
                        src={`data:application/pdf;base64,${tAndC}`}
                        title="Terms and Conditions"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                    />
                )}
            </Paper>
            {/* {showAgreement && ( */}
                <div style={{ padding: '16px', textAlign: 'center' }}>
                    <Typography variant="body1" style={{ marginBottom: '16px' }}>
                        I have read and agree to the Terms and Conditions
                    </Typography>
                    <Button
                        variant="contained"
                        color={agreement ? 'default' : "primary"}
                        disabled={agreement ? true : false}
                        onClick={() => handleAgreement({ target: { checked: true } })}
                    // style={{
                    //     backgroundColor: agreement ? '#3f51b5' : '#f0f0f0',
                    //     color: agreement ? '#fff' : '#000',
                    //     fontWeight: 'bold'
                    // }}
                    >
                        Click here to Agree
                    </Button>
                </div>
            {/* )} */}
        </Drawer>
    );
}